var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.result.hotel.media)?_c('b-carousel',{attrs:{"id":"carousel-fade","controls":"","interval":0}},_vm._l((_vm.result.hotel.media),function(image){return _c('b-carousel-slide',{key:image.url,scopedSlots:_vm._u([{key:"img",fn:function(){return [_c('div',{staticClass:"gallery",style:({
                    backgroundImage: 'url(' + image.uri + ')',
                })})]},proxy:true}],null,true)})}),1):_c('div',{staticClass:"placeholder-img"})
}
var staticRenderFns = []

export { render, staticRenderFns }